import Crehana from '../icon/crehana.svg'
import CrehanaBW from '../icon/crehana-bw.svg'
import Google from '../icon/google.svg'
import GoogleBW from '../icon/google-bw.svg'
import BienestarMayor from '../icon/adultomayor.png'
import BienestarMayorBW from '../icon/adultomayor-bw.png'
import Banconsejos from '../icon/banconsejos.svg'
import BanconsejosBW from '../icon/banconsejos-bw.svg'
import LaChiripa from '../icon/lachiripa-color.png'
import LaChiripaBW from '../icon/lachiripa-bw.png'

export const PROVIDERS = [
  'crehana',
  'banconsejos',
  'bancaaprende',
  'google',
  'lachiripa'
]

export const LACHIRIPA_TYPES = [
  'serie',
  'capsule'
]

export const PROVIDERS_RASTER_LOGOS = ['lachiripa', 'bancaaprende']

export const PROVIDERS_LOGO_WIDTH_MAP = {
  lachiripa: 176,
  bancaaprende: 106
}

export const PROVIDERS_LOGO_HEIGHT_MAP = {
  lachiripa: 32,
  bancaaprende: 48
}

export const PROVIDERS_COLOR_MAP = {
  crehana: 'green-500',
  google: 'red-500',
  bancaaprende: 'turquoise-600',
  banconsejos: 'yellow-500',
  lachiripa: 'green-500'
}

export const PROVIDERS_AUTHOR_NAME_MAP = {
  bancaaprende: 'Bienestar Mayor'
}

export const PROVIDERS_TEXT_MAP = {
  crehana: 'Desarrollo laboral por',
  google: 'Herramientas de productividad por',
  bancaaprende: 'Educación para Adulto Mayor por',
  banconsejos: 'Educación financiera por',
  lachiripa: 'Educación infantil por'
}

export const PROVIDERS_ICON_MAP = {
  crehana: Crehana,
  google: Google,
  bancaaprende: BienestarMayor,
  banconsejos: Banconsejos,
  lachiripa: LaChiripa
}

export const PROVIDERS_BWICON_MAP = {
  crehana: CrehanaBW,
  google: GoogleBW,
  bancaaprende: BienestarMayorBW,
  banconsejos: BanconsejosBW,
  lachiripa: LaChiripaBW
}
